"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Back = _interopRequireDefault(require("Layouts/Back"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
var _Routing = require("Functions/Routing");
var _Dashboard = _interopRequireDefault(require("Components/Lists/Dashboard"));
var _ProjectRow = _interopRequireDefault(require("Components/Lists/Rows/ProjectRow"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ProjectsDashboardPage = () => {
  const [searchedProject, setSearchedProject] = (0, _react.useState)("");
  const [searchedPratician, setSearchedPratician] = (0, _react.useState)("");
  const role = app.state.session.user.roles[0];
  const screenWidth = window.screen.width;
  const header = [{
    name: 'id',
    label: 'Dossier'
  }, {
    name: 'surgery_date',
    label: 'Date de chirurgie'
  }, {
    name: 'stl_type',
    label: 'STL'
  }, {
    name: 'created_by',
    label: 'Praticien'
  }];
  if (role === "pratician") {
    delete header[3];
  }
  if (screenWidth < 1200) {
    delete header[2];
    delete header[3];
  }
  const fields = header.map(infos => infos.name);
  let orthoFilter = {};
  if (role === 'ortho') {
    orthoFilter = {
      shared_with: app.state.session.user.login
    };
  } else undefined;
  let filters = {
    record_number: searchedProject,
    searched_pratician: searchedPratician
  };
  return /*#__PURE__*/_react.default.createElement(_Back.default, {
    page_title: "Les dossiers "
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "o-content dashboard-page"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-right"
  }, role === "pratician" ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    href: (0, _Routing.URL)('NewProject'),
    className: (0, _bemit.default)('c-flat-btn', ['primary'])
  }, "Nouvelle demande") : undefined), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-filters c-filters--users"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-filters__element"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setSearchedProject(e.value),
    placeholder: " Rechercher un dossier",
    value: searchedProject,
    name: "searched",
    status: {}
  }))), role === "deltex" ? /*#__PURE__*/_react.default.createElement("div", {
    className: "c-filters c-filters--users"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-filters__element"
  }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
    onChange: e => setSearchedPratician(e.value),
    placeholder: " Rechercher un praticien",
    value: searchedPratician,
    name: "searched",
    status: {}
  }))) : undefined), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-double-dashboard"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-dashboard"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "project_infos__status-open"
  }, "Dossiers ouverts :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding "
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: header,
    fields: fields,
    component: _ProjectRow.default,
    "items-per-page": 5,
    filters: _objectSpread(_objectSpread(_objectSpread({}, filters), orthoFilter), {}, {
      project_status: 'open'
    })
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-dashboard"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "project_infos__status-running"
  }, "Dossiers en cours :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: header,
    fields: fields,
    component: _ProjectRow.default,
    "items-per-page": 5,
    filters: _objectSpread(_objectSpread(_objectSpread({}, filters), orthoFilter), {}, {
      project_status: 'running'
    }),
    "order-by": "surgery_date",
    order: "ASC"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-double-dashboard"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "project-dashboard"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "project_infos__status-pending"
  }, "Dossiers en attente :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: header,
    fields: fields,
    component: _ProjectRow.default,
    "items-per-page": 5,
    filters: _objectSpread(_objectSpread(_objectSpread({}, filters), orthoFilter), {}, {
      project_status: 'pending'
    })
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "project-dashboard"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "project_infos__status-over"
  }, "Dossiers termin\xE9s :"), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: header,
    fields: fields,
    component: _ProjectRow.default,
    "items-per-page": 5,
    filters: _objectSpread(_objectSpread(_objectSpread({}, filters), orthoFilter), {}, {
      project_status: 'over'
    })
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dashboard-table u-margin-bottom-25 o-content",
    style: {
      overflow: 'initial'
    }
  }, /*#__PURE__*/_react.default.createElement("h2", null, "Tous les dossiers : "), /*#__PURE__*/_react.default.createElement("div", {
    className: "c-paper u-padding-top-0 no-horizontal-padding"
  }, /*#__PURE__*/_react.default.createElement(_Dashboard.default, {
    model: "Project",
    url: (0, _Routing.action)('getAllProjects'),
    header: header,
    fields: fields,
    component: _ProjectRow.default,
    "items-per-page": 30,
    filters: _objectSpread(_objectSpread({}, filters), orthoFilter)
  }))));
};
var _default = exports.default = ProjectsDashboardPage;
